// src/utils/isRecoveryFlow.ts
export function isRecoveryFlow(href = window.location.href) {
  const u = new URL(href);

  // Hash params: #access_token=...&type=recovery&...
  const hash = u.hash.startsWith("#") ? u.hash.slice(1) : u.hash;
  const h = new URLSearchParams(hash);
  const hashRecovery = (h.get("type") || "").toLowerCase() === "recovery";
  const hashHasToken = h.has("access_token");

  // Search params:
  // 1) New PKCE style: ?code=...
  // 2) Legacy verify link you pasted: ?token=...&type=recovery
  const searchType = (u.searchParams.get("type") || "").toLowerCase();
  const hasCode    = u.searchParams.has("code");
  const hasToken   = u.searchParams.has("token"); // <- important for /verify?token=...&type=recovery
  const searchRecovery = searchType === "recovery" && (hasCode || hasToken || true);

  // Already on reset page counts too
  const onReset = u.pathname.includes("/auth/reset-password");

  return hashRecovery || hashHasToken || searchRecovery || hasCode || onReset;
}
